<template>
<div class="mh100vh b_fff withdrawal">
  <div class="pt20 pl24 pr24 ">
    <div class="df jcsa fz28 c_333">
      <div @click="choose(1)" :class="type==1?'b_red c_fff':'b_e'" class="pt25 pb25 bdrd8 fx1 df aic jcc ">
          <img v-if="type==1" src="./assets/img/w1_h.png" alt="" class="all36 mr14">
          <img v-else src="./assets/img/w1.png" alt="" class="all36 mr14">
          衣印余额
      </div>
      <div @click="choose(2)" :class="type==2?'b_red c_fff':'b_e'" class="pt25 pb25 bdrd8 ml16 mr16 fx1 df aic jcc">
          <img v-if="type==2" src="./assets/img/w2_h.png" alt="" class="all36 mr14">
          <img v-else src="./assets/img/w2.png" alt="" class="all36 mr14">
          微信钱包
      </div>
      <div @click="choose(3)" :class="type==3?'b_red c_fff':'b_e'" class="pt25 pb25 bdrd8 fx1 df aic jcc">
          <img v-if="type==3" src="./assets/img/w3_h.png" alt="" class="all36 mr14">
          <img v-else src="./assets/img/w3.png" alt="" class="all36 mr14">
          支付宝账户
      </div>
    </div>
    <div v-if="type==2||type==3" class="box1 mt10 bdrd8 tac pb30">
      <div class="tac fz28 c_fff pt30">提现到<span v-if="type==2">微信钱包</span><span v-if="type==3">支付宝账号</span></div>
      <div v-if="type==2">
        <div v-if="wechat" class="fz28 c_fff mt16 h64 df aic jcc">{{wechat}}</div>
        <div v-else class="fz28 c_fff m0a mt16 h64 df aic jcc b_fff w280 bdrd50">
          <input type="text" v-model="wechatinp" placeholder="请输入微信钱包账户" class="weui-input fz28 c_333 tac">
        </div>
      </div>
      <div v-if="type==3">
        <div v-if="ali" class="fz28 c_fff mt16 h64 df aic jcc">{{ali}}</div>
        <div v-else class="fz28 c_fff m0a mt16 h64 df aic jcc b_fff w280 bdrd50">
          <input type="text" v-model="aliinp" placeholder="请输入支付宝账户" class="weui-input fz28 c_333 tac">
        </div>
        <div class="fz28 c_fff m0a mt16 h64 df aic jcc b_fff w280 bdrd50">
          <input type="text" v-model="name" placeholder="请输入真实姓名" class="weui-input fz28 c_333 tac">
        </div>
      </div>
    </div>

    <div class="pt40 fz30 c_333">提现金额</div>
    <div class="pt36 df aic">
      <div class="fz60 c_333">￥</div>
      <input v-model="money" type="number" :placeholder="'可提现余额'+info.withdraw+'元'" class="weui-input pl24 fx1 fz28 c_333">
      <div @click="setmoney" class="fz28 c_red">全部提现</div>
    </div>
    <div class="h1 b_d8"></div>

    <div class="mt50">
      <button @click="submit()" v-bind:disabled="subdisabled" class="withbtn db lh80 tac bdrd50 fz30 c_fff" :class="[subdisabled?'disabled b_c':'b_red']">提现</button>
    </div>
    <div class="pt100 fz24 c_999">
      <div>衣印余额提现介绍</div>
      <div class="mt24">
        1、提现到衣印余额无需申请，方便快捷。<br>
        2、衣印余额仅可用于衣印公众号洗衣服务，不可转为现金。
      </div>
    </div>
  </div>
<transition name="fade">
<div v-if="confirmPopShow" class="yajintips">
    <div class="popb">
      <div class="yajintips_box1 pb40 b_fff">
        <img @click="confirmPopShow=false" src="@/assets/img/close1.png" alt="" class="w53 h91 poa b_91 l264">
        <div class="fz32 c_333 pt40 tac por ovh">提示</div>
        <!-- <div class="roll"></div> -->
        <div class="pt30 fz28 c_666 pl40 pr40">
            确认收益提现？<br>
            <!-- {{confirmInfo}} -->
            提现金额： ¥{{confirmInfo.money}}<br>
            提现方式：
                <span v-if="confirmInfo.category==1">衣印余额</span>
                <span v-if="confirmInfo.category==2">微信钱包</span>
                <span v-if="confirmInfo.category==3">支付宝账户</span><br>
            <span v-if="confirmInfo.category==2">
                提现信息： {{confirmInfo.wechat}}
            </span>
            <span v-if="confirmInfo.category==3">
                提现信息： {{confirmInfo.ali}} {{confirmInfo.name}} 
            </span>
        </div>
        <div class="pt40 pl40 pr40 tac df jcsb fz30">
          <div @click="confirmPopShow=false" class="btn2 w206 lh78 bdrd50 c_666">取消</div>
          <div @click="getApi" class="w206 lh80 bdrd50 c_fff b_red">确认</div>
        </div>
      </div>
    </div>
</div>
</transition>

    <transition name="fade">
    <message v-if="successPopShow" :time="3000" @myevent="myevent">
      <div class="fz28 c_333 mt10">提现成功</div>
      <div class="fz28 c_999">
        <span v-if="type==1">已提现到衣印余额</span>
        <span v-if="type==2||type==3">已为您提交提现申请，请耐心等待</span>
      </div>
      <div class="fz32 c_666">提现金额: {{money}}元</div>
    </message>
    </transition>
  </div>
</template>
<script>
import weui from 'weui.js'
import message from '@/components/message'
export default {
  components:{
    message
  },
  data() {
    return {
      type:1,

      confirmPopShow:false,
      info:{withdraw:0},
      money:'',
      successPopShow:false,

      wechat:'',
      wechatinp:'',
      ali:'',
      aliinp:'',
      name:''
    }
  },
  mounted(){
    this.getYongjin();
  },
  computed:{
    subdisabled(){
      let vm = this;
      let result = false;
      if(vm.type==1&&vm.money>0) result = true;
      if(vm.type==2&&vm.money>0&&(vm.wechat||vm.wechatinp)) result = true;
      if(vm.type==3&&vm.money>0&&(vm.ali||vm.aliinp)&&vm.name) result = true;
      return !result
    }
  },
  methods:{
    getYongjin(){
      let vm = this;
      vm.ajax("account/yongjin", "get", '', e => {
        vm.info = e.data;
        // //test
        // vm.info.withdraw = 100;
        // //test
      })
    },
    setmoney(){
      let vm = this;
      if(vm.info.withdraw>0){
        vm.money = vm.info.withdraw;
      }else{
        vm.publics.message.danger('可提现金额为0');
      }
    },
    myevent(e){
      if(e.close){
        this.successPopShow = false;
      }
    },
    choose(type){
      this.type = type;
    },
    submit(){
      let vm = this;
      // vm.publics.message.danger('账户没有足够的佣金(0.00)，请体协正确的数字');
      // return;
      vm.money = vm.money*1;
      if(!(vm.money>0)){
        vm.publics.message.danger('请输入金额');
        return false;
      }
      if(!(/^(([1-9]{1}\d*)|(0{1}))(\.\d{0,2})?$/).test(vm.money)){
        vm.publics.message.danger('请输入正确的金额，最多2位小数');
        return false;
      }
      let data = {
        money:vm.money,
        category:vm.type
      }
      if(vm.type==2){
        if(!vm.wechatinp&&!vm.wechat){
          vm.publics.message.danger('请输入微信钱包账户');
          return false;
        }
        if(!(/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/).test(vm.wechatinp)){
          vm.publics.message.danger('请输入正确的微信钱包账户');
          return false;
        }
        data.wechat = vm.wechat?vm.wechat:vm.wechatinp
      }
      if(vm.type==3){
        if(!vm.aliinp&&!vm.ali){
          vm.publics.message.danger('请输入支付宝账户');
          return false;
        }
        if(!(/^(?:\w+\.?)*\w+@(?:\w+\.)+\w+|\d{9,11}$/).test(vm.aliinp)){
          vm.publics.message.danger('请输入正确的支付宝账户');
          return false;
        }
        data.ali =  vm.ali?vm.ali:vm.aliinp
        if(!vm.name){
          vm.publics.message.danger('请输入真实姓名');
          return false;
        }
        data.name = vm.name
      }

      vm.confirmPopShow = true;
      vm.confirmInfo = data;
    },
    getApi(){
        this.ajax("account/yongjin/withdraw", "post", this.confirmInfo, e => {
            this.confirmPopShow = false;
            this.successPopShow = true;
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/withdrawal.vue